import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';

import Navigation, { INavigationItem } from './Navigation';
import { Sidebar } from '@destination/components';

import InfoIcon from '@icons/info_16.svg?react';
import ArrowIcon from '@icons/arrowRightIcon.svg?react';

export const SMG_INFO_URL =
  'https://abbevci.visualstudio.com/DS.SmartGatePlatform/_wiki/wikis/SmartGate%20functionality%20SDK/33225/SmartGate-Functionality-SDK';

export default function FooterNavigation() {
  const { t } = useTranslation(undefined, { keyPrefix: 'navigation' });
  const { instance } = useMsal();

  const menuItems: INavigationItem[] = [
    { icon: <InfoIcon />, label: 'info', url: SMG_INFO_URL, newTab: true }
  ];

  const handleLogout = async () => {
    await instance.logout();
  };

  return (
    <>
      <Navigation items={menuItems} />
      <div className="cursor-pointer" onClick={handleLogout}>
        <Sidebar.MenuItem
          icon={<ArrowIcon />}
          isActive={false}
          label={t('logout')}
        />
      </div>
    </>
  );
}
